module.exports = "delete-x-small"